import { Component, OnInit } from '@angular/core';
import { Router, RouterModule, Routes } from '@angular/router';
import { LoyaltyService } from '../../../../../../shared/_services/loyalty.service';
import { LoginService } from '../../../../../../shared/_services/login.service';
import { environment } from '../../../../../../../environments/environment';

@Component({
  selector: 'app-hca-loyalty-website-preview',
  templateUrl: './hca-loyalty-website-preview.component.html',
  styleUrls: ['./hca-loyalty-website-preview.component.scss']
})
export class HcaLoyaltyWebsitePreviewComponent implements OnInit {
  bannerMemberData: any;
  headerAndFooterData: any[] = [];
  memberConfig: any;
  heroBanner: any;
  heroMemberData: any;
  catalogRewardsData : any;
  catalogRewardsList : any[] = [];
  langType: any;
  fontData: any;
  brandId: any;
  headerAndFooter: any;
  HeaderAndFooter: any;
  cssTextStyle: any;
  environment = environment;
  imageUrl = '/assets/images/sandos-banner.jpg';
  constructor(
     public router: Router,
     private loginService: LoginService,
     private loyaltyService: LoyaltyService
    ) {
  }

  createStyle(css, styleId) {
    var css = css,
    head = document.getElementsByTagName('head')[1] || document.head || document.getElementsByTagName('head')[0],
    style: any = document.createElement('style');
    style.type = 'text/css';
    style.id = styleId;
    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
    head.appendChild(style);
  }

  removeStyle(styleId) {
    var hs = document.getElementsByTagName('head')[1].getElementsByTagName(`style`);
    var head = document.getElementsByTagName('head')[1];
    while (head.firstChild) {
      if((<Element>head.firstChild)) {
        head.removeChild(head.firstChild);
      }
    }
  }

  getHeaderData(brandId) {
    this.loyaltyService.getHeaderAndFooter(brandId).subscribe(res => {
      if(res.error == 0) {
        if(res.responseObj && res.responseObj.length) {
          this.headerAndFooterData = res.responseObj;
          this.setheaderAndFooter(this.headerAndFooterData);
        } else {
          this.headerAndFooter = {
            headerHtml: null,
            headerCss: null,
            footerHtml: null,
            footerCss: null
          }
        }
      }
    }, err => {
      console.error('Error fetching loyalty website header and footer data', err);
    })
  }

  getWebsiteCss(brandId) {
    this.loyaltyService.getWebsiteCss(brandId).subscribe(res => {
      if(res.error == 0) {
        if(res.responseObj ) {
          this.setWebsiteCss(res.responseObj.cssTextStyle);
        } else {
          this.cssTextStyle = null
        }
      }
    }, err => {
      console.error('Error fetching loyalty website css data', err);
    })
  }

  getWebsiteHeroMemberData(brandId) {
    this.loyaltyService.getWebsiteHeroMemberData(brandId).subscribe(res => {
      if(res.error == 0) {
        if(res.responseObj) {
          this.bannerMemberData = res.responseObj;
          this.setBannerMemberData(this.bannerMemberData)


        } else {
          this.heroMemberData = null;
        }
      }
    }, err => {
      console.error('Error fetching loyalty website css data', err);
    })
  }

  getCatalogRewards(brandId , langId) {
    this.loyaltyService.getCatalogRewards(brandId , langId).subscribe(res => {
      if(res.error == 0) {
        if(res.responseObj ) {
          this.catalogRewardsList = res.responseObj;
          console.log(this.catalogRewardsList);
        } else {

        }
      }
    }, err => {
      console.error('Error fetching getCatalogRewards data', err);
    })
  }

 getImgStyle(id, bgImg, src?, style?, type?) {
    if(type == 'bgImg') {

      return `url('${environment.BASE_IMAGE_API}/images/${src}/${id}/${bgImg}') ${style}`;
    } else {
      return `${environment.BASE_IMAGE_API}/images/${src}/${id}/${bgImg}`;
    }

  }


  goTo(type, url) {
    type == 'External URL' ? window.open(`https://${url}`, '_blank') : false;
  }

  changeLang(type) {
    this.removeStyle('fontData');
    this.langType = type == 'en' ? {languageId: 1, language: 'English'} : {languageId: 2, language: 'Spanish'};
    console.log(this.langType.languageId);
    this.setWebsiteCss(this.fontData);
    this.setheaderAndFooter(this.headerAndFooterData);
    this.setBannerMemberData(this.bannerMemberData);
    this.getCatalogRewards(this.brandId, this.langType.languageId);
  }

  setBannerMemberData(bannerMemberData?) {
    this.heroBanner = null;
    this.memberConfig = null;
    if(bannerMemberData.heroBannerTypeDataTos.length) {
      bannerMemberData.heroBannerTypeDataTos.forEach(heroBanner => {
        if(heroBanner.languageId == this.langType.languageId) {
          this.heroBanner = heroBanner;
        }
      })
    }
    if(bannerMemberData.memberUpgradeConfigurationTo && bannerMemberData.memberUpgradeConfigurationTo.newMemberConfigTos.length) {
      bannerMemberData.memberUpgradeConfigurationTo.newMemberConfigTos.forEach(memberConfig => {
        if(memberConfig.languageId == this.langType.languageId) {
          this.memberConfig = memberConfig;
        }
      })
    }
  }

  setheaderAndFooter(headerAndFooterData?) {
    this.HeaderAndFooter = null;
    headerAndFooterData.forEach(data => {
      if(data.languageId == this.langType.languageId) {
        this.setheaderAndFooterCss(data, data.languageId);
      }
    })
  }

  setheaderAndFooterCss(headerAndFooter?, langId?) {
    this.HeaderAndFooter = headerAndFooter;
    if(this.HeaderAndFooter.headerCss) {
      this.createStyle(this.HeaderAndFooter.headerCss, `headerCss${langId}`);
    }
    if(this.HeaderAndFooter.footerCss) {
      this.createStyle(this.HeaderAndFooter.footerCss, `footerCss${langId}`);
    }
  }

  setWebsiteCss(cssTextStyle?, langId?) {
    this.fontData = cssTextStyle;
    this.createStyle(this.fontData, `fontData`);
  }

  logout(){
    this.loginService.logout().subscribe(
      data => {
        localStorage.clear();
        this.router.navigate(['/login']);
      }, error => {
        console.error('Logout failed : ' + error);
      });
  }

  ngOnInit() {
    // this.brandId = this.winRef.nativeWindow.brandId ? this.winRef.nativeWindow.brandId : (localStorage.getItem('loggedInUser') && JSON.parse(localStorage.getItem('loggedInUser')).brandId ? JSON.parse(localStorage.getItem('loggedInUser')).brandId : 7603);
    this.brandId = localStorage.getItem('loggedInUser') && JSON.parse(localStorage.getItem('loggedInUser')).brandId ? JSON.parse(localStorage.getItem('loggedInUser')).brandId : 7603;
    // this.langType = this.winRef.nativeWindow.langType ? this.winRef.nativeWindow.langType : {languageId: 1, language: 'English'};
    this.langType = {languageId: 1, language: 'English'};
    // this.headerAndFooter = this.winRef.nativeWindow.headerAndFooter ? this.setheaderAndFooter(JSON.parse(this.winRef.nativeWindow.headerAndFooter)) : this.getHeaderData(this.brandId);
    this.headerAndFooter = this.getHeaderData(this.brandId);
    // this.fontData = this.winRef.nativeWindow.fontData ? this.setWebsiteCss(JSON.parse(this.winRef.nativeWindow.fontData).cssTextStyle) : this.getWebsiteCss(this.brandId);
    this.fontData = this.getWebsiteCss(this.brandId);
    this.heroMemberData = this.getWebsiteHeroMemberData(this.brandId);
    this.catalogRewardsData = this.getCatalogRewards(this.brandId , 1);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/settings/hca-loyalty-website/hca-loyalty-website-preview/hca-loyalty-website-preview.component.ts